import domReady from '@wordpress/dom-ready';

domReady(async () => {
	const hubspotBannerSelector = '#hs-web-interactives-top-push-anchor';
	const intercomBannerSelector = 'iframe[name="intercom-banner-frame"]';

	const navbarElement = document.querySelector('.js-block-navbar');
	const progressBarElement = document.querySelector('.js-progress-bar');

	if (!navbarElement && !progressBarElement) {
		return;
	}

	const elementsToPushDown = [navbarElement, progressBarElement].filter((item) => item != null);

	const { BannerHelper } = await import('./banner-helper');

	const helper = new BannerHelper({
		hubspotBannerSelector: hubspotBannerSelector,
		intercomBannerSelector: intercomBannerSelector,
		elementsToPushDown: elementsToPushDown,
	});

	helper.init();
});
